import React, { FunctionComponent, useEffect, useState } from "react"
import { Controller, useFieldArray, useFormContext } from "react-hook-form"
import { userRoles, visibilityLevels } from "../../../api/Definitions"
import AsyncPaginateSelectInput from "../../../components/Form/Select/AsyncPaginateSelectInput"
import SelectInput from "../../../components/Form/Select/Select"
import Loader from "../../../components/Loader/Loader"
import { iAccess } from "../../../definitions/Access"
import { iResponse } from "../../../definitions/interfaces"
import { iUser } from "../../../definitions/User"
import { get } from "../../../store/data/actions"
import NoPermission from "../../NoPermission/NoPermission"

interface iProps {
  access?: iAccess
  rootUrl?: string
}

const ArtPieceAccess: FunctionComponent<iProps> = ({ access }) => {
  const [loading, setLoading] = useState(true)
  const [noPermission, setNoPermission] = useState(true)
  const [defaultUsers, setDefaultUsers] = useState<iUser[]>([])

  // const users = useSelector(({ data }) => data.users)
  const { register, control } = useFormContext()
  const { fields } = useFieldArray({
    control,
    name: "__access.users",
  })

  const loadUsers = async (input: string, skip: number) => {
    try {
      const result = await get<iResponse<iUser[]>>({
        link: "/v1/users-list",
        query: { email: input, skip },
      })
      console.log(result)

      return result
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    register("__access")
  }, [])

  useEffect(() => {
    if (!access?.canDelete) {
      setNoPermission(true)
    } else {
      setNoPermission(false)
    }

    const usrs = access?.users.map((a) => a._id)

    get<iResponse<iUser[]>>({
      link: "/v1/users-list",
      query: { preload: usrs },
    }).then((res) => {
      console.log(res)
      setDefaultUsers(res.data)
      setLoading(false)
    })
  }, [access])

  return loading ? (
    <Loader />
  ) : noPermission ? (
    <NoPermission />
  ) : (
    <div className="container">
      <Controller
        as={SelectInput}
        name="access.visibilityLevel"
        options={visibilityLevels}
        label="Visibility"
      />
      <ul>
        <h4>Permission list</h4>
        {fields.map((field, index) => (
          <li className="row" key={index}>
            <div className="col-6">
              <Controller
                control={control}
                render={({ value, onChange }) => (
                  <AsyncPaginateSelectInput
                    value={value}
                    onChange={onChange}
                    name={`access.users[${index}]._id`}
                    loadOptions={loadUsers}
                    label="User"
                    defaultOptions={defaultUsers}
                    isClearable
                  />
                )}
                name={`access.users[${index}]._id`}
                defaultValue={field._id}
              />
            </div>
            <div className="col-6">
              <Controller
                control={control}
                render={({ value, onChange }) => (
                  <SelectInput
                    value={value}
                    onChange={onChange}
                    name={`access.users[${index}].role`}
                    options={userRoles}
                    label="Role"
                  />
                )}
                name={`access.users[${index}].role`}
                defaultValue={field.role}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ArtPieceAccess
